<template>
  <div>
    <el-form-item label="PIX 类型" prop="pix_type">
      <el-select
        v-model="form.pix_type"
        placeholder="请选择 PIX 类型"
        style="width: 100%"
        @change="handlePixTypeChange"
      >
        <el-option v-for="opt in pixTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="pixValueLabel" prop="card_no">
      <el-input
        v-model="form.card_no"
        :placeholder="pixValuePlaceholder"
        :maxlength="inputMaxLength"
        :show-word-limit="!!inputMaxLength"
        clearable
        @input="handleCardNoFormat"
      ></el-input>
    </el-form-item>
  </div>
</template>

<script>
const PIX_TYPE_OPTIONS = [
  { value: 'CPF', label: 'CPF' },
  { value: 'PHONE', label: 'PHONE' },
  { value: 'CNPJ', label: 'CNPJ' },
  { value: 'EMAIL', label: 'EMAIL' },
]

export default {
  name: 'BankAccountFormFieldsBr',
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pixTypeOptions: PIX_TYPE_OPTIONS,
    }
  },
  computed: {
    inputMaxLength() {
      const t = this.form.pix_type
      if (t === 'CPF') return 11
      if (t === 'CNPJ') return 14
      if (t === 'PHONE') return 11
      return undefined
    },
    pixValueLabel() {
      const map = { CPF: 'CPF', PHONE: 'PHONE', CNPJ: 'CNPJ', EMAIL: 'EMAIL' }
      return map[this.form.pix_type] || 'PIX 账号'
    },
    pixValuePlaceholder() {
      const t = this.form.pix_type
      if (t === 'CPF') return '请输入 11 位 CPF'
      if (t === 'CNPJ') return '请输入 14 位 CNPJ'
      if (t === 'PHONE') return '请输入 10～11 位手机号'
      if (t === 'EMAIL') return '请输入邮箱'
      return '请输入 PIX 账号'
    },
  },
  watch: {
    'form.pix_type'() {
      this.form.card_type = 'PIX'
    },
  },
  mounted() {
    this.form.card_type = 'PIX'
  },
  methods: {
    handlePixTypeChange() {
      this.form.card_type = 'PIX'
      this.form.card_no = ''
      this.form.mobile = ''
      this.form.email = ''
    },
    handleCardNoFormat(raw) {
      const t = this.form.pix_type
      if (t === 'CPF' || t === 'CNPJ' || t === 'PHONE') {
        const digits = String(raw || '').replace(/\D/g, '')
        const max = t === 'CPF' ? 11 : t === 'CNPJ' ? 14 : 11
        this.form.card_no = digits.slice(0, max)
      }
    },
  },
}
</script>
